import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import RcsSupplierInfoTable from './RcsSupplierInfoTable';

import './RcsSupplierInfoDialog.scss';

const spinnerId = 'id';

export default function RcsSupplierInfoDialog(props) {
  const { supplierInfo } = props;

  const spinnerOrTable = !supplierInfo ? (
    <RxSpinnerComponent spinnerScale={1} autoStart spinnerId={spinnerId} />
  ) : (
    <RcsSupplierInfoTable {...props} />
  );

  return (
    <GeneralDialogLayout
      {...props}
      size="lg"
      dialogTitleId="rcs-supplier-info-title"
      headerClassName="rcs-supplier-info--header"
      contentClassName="rcs-supplier-info--content u-els-padding-left u-els-padding-right"
      header={
        <h4 id="rcs-supplier-info-title" className="rcs-supplier-info--header-text">
          Supplier information
        </h4>
      }
      footer={null}>
      {spinnerOrTable}
    </GeneralDialogLayout>
  );
}

RcsSupplierInfoDialog.propTypes = {
  supplierInfo: PropTypes.instanceOf(Map),
};
